module.exports = __webpack_public_path__ + "src/assets/img/m46.d87cab9b.svg";